var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlowerHighHeaterOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Blower_High_Speed_Heater_OFF",
    "data-name": "Blower High Speed_Heater OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 508,
    height: 48,
    viewBox: "0 0 508 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M439.23,27.06a7.682,7.682,0,0,1-5.21-2.12,1.331,1.331,0,0,1-.01-1.86,1.3,1.3,0,0,1,1.83-.02c.33.32,3.25,2.97,6.93-.08a8.008,8.008,0,0,1,10.7.04,1.321,1.321,0,0,1,.09,1.85,1.278,1.278,0,0,1-1.83.09,5.413,5.413,0,0,0-7.31.04A7.977,7.977,0,0,1,439.23,27.06Z",
    fill: "#b6d3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M439.23,34.02a7.682,7.682,0,0,1-5.21-2.12,1.331,1.331,0,0,1-.01-1.86,1.286,1.286,0,0,1,1.83-.02c.33.32,3.25,2.97,6.93-.08a8.008,8.008,0,0,1,10.7.04,1.321,1.321,0,0,1,.09,1.85,1.278,1.278,0,0,1-1.83.09,5.413,5.413,0,0,0-7.31.04A7.925,7.925,0,0,1,439.23,34.02Z",
    fill: "#b6d3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M439.23,40.99a7.682,7.682,0,0,1-5.21-2.12,1.331,1.331,0,0,1-.01-1.86,1.3,1.3,0,0,1,1.83-.02c.33.32,3.25,2.97,6.93-.08a8.008,8.008,0,0,1,10.7.04,1.321,1.321,0,0,1,.09,1.85,1.278,1.278,0,0,1-1.83.09,5.413,5.413,0,0,0-7.31.04A7.977,7.977,0,0,1,439.23,40.99Z",
    fill: "#b6d3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M439.23,47.96a7.682,7.682,0,0,1-5.21-2.12,1.331,1.331,0,0,1-.01-1.86,1.3,1.3,0,0,1,1.83-.02c.33.32,3.25,2.97,6.93-.08a8.008,8.008,0,0,1,10.7.04,1.321,1.321,0,0,1,.09,1.85,1.278,1.278,0,0,1-1.83.09,5.413,5.413,0,0,0-7.31.04A7.977,7.977,0,0,1,439.23,47.96Z",
    fill: "#b6d3ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M506.38.33H481.47a1.306,1.306,0,0,0-1.3,1.31V6.81a20.92,20.92,0,0,0-13.13,13.77H460.1a1.306,1.306,0,0,0-1.3,1.31V46.36a1.3,1.3,0,0,0,1.3,1.31h25.98v-.04c.28.01.55.04.83.04a20.885,20.885,0,0,0,20.76-21.01c0-.24-.03-.48-.04-.72h.04V1.64A1.3,1.3,0,0,0,506.38.33Z",
    fill: "#b6d3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M486.91,48c-.18,0-.35-.01-.53-.02h-.07l-.22.02H460.1a1.637,1.637,0,0,1-1.62-1.64V21.89a1.63,1.63,0,0,1,1.62-1.64h6.7A21.27,21.27,0,0,1,479.85,6.58V1.64A1.63,1.63,0,0,1,481.47,0h24.91A1.637,1.637,0,0,1,508,1.64l-.02,24.63c.01.13.02.26.02.39A21.238,21.238,0,0,1,486.91,48Zm-.81-.7c.11,0,.22.01.33.02.16.01.32.02.48.02a20.587,20.587,0,0,0,20.44-20.68c0-.14-.01-.27-.02-.4-.01-.1-.01-.2-.02-.31l-.01-.34h.05V1.64a.98.98,0,0,0-.97-.98H481.47a.973.973,0,0,0-.97.98v5.4l-.22.08a20.645,20.645,0,0,0-12.93,13.55l-.07.23H460.1a.973.973,0,0,0-.97.98V46.35a.98.98,0,0,0,.97.98Z",
    fill: "#404041"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9825",
    "data-name": "Group 9825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M427.23,38.76h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0H372.5V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0H288.8V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0H205.1V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12H189Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0H121.4V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0H95.64V30.12h3.22Zm-6.43,0H89.21V30.12h3.22Zm-6.44,0H82.77V30.12h3.22Zm-6.44,0H76.33V30.12h3.22Zm-6.44,0H69.89V30.12h3.22Zm-6.44,0H63.45V30.12h3.22Zm-6.44,0H57.01V30.12h3.22Zm-6.44,0H50.57V30.12h3.22Zm-6.43,0H44.14V30.12h3.22Zm-6.44,0H37.7V30.12h3.22v8.64Zm-6.44,0H31.26V30.12h3.22Zm-6.44,0H24.82V30.12h3.22Zm-6.44,0H18.38V30.12H21.6Zm-6.44,0H11.94V30.12h3.22Z",
    fill: "#b6d3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9824",
    "data-name": "Group 9824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9823",
    "data-name": "Group 9823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M9.35,39.58,4.29,34.46l5.06-5.12H5.06L0,34.46l5.06,5.12Z",
    fill: "#b6d3ff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlowerHighHeaterOff);
export default __webpack_public_path__ + "static/media/blower_high_heater_off.b2e92cd7abafccfcc3bc1b272191d169.svg";
export { ForwardRef as ReactComponent };